import React from 'react';
import { sendRatClickEvent } from '../../utils/rat';
import { useRootStore } from '../../App';

interface Props {
  children: any;
  componentId: string;
}

export const RatClickTracker = (props: Props) => {
  const root = useRootStore();
  const { user, inquiryTarget } = root.userStore;
  const { activeInquiry, isRecipientTypingMessage } = root.inquiryStore;
  const { inputSelectionMap } = root.faqStore;
  const { children, componentId } = props;

  return (
    <div
      onClick={() =>
        sendRatClickEvent({
          customParameter: {
            ...inputSelectionMap,
            serviceId: user.serviceId,
            serviceAttribute: user.serviceAttribute,
            categoryId: activeInquiry
              ? activeInquiry.categoryId
              : inquiryTarget.categoryId,
            inquiryCategoryId: activeInquiry?.inquiryCategory,
            inquirySubCategoryId: activeInquiry?.inquirySubCategory,
            targetId: activeInquiry
              ? activeInquiry.targetId
              : inquiryTarget.targetId,
            isRecipientActive: isRecipientTypingMessage,
          },
          componentId: componentId,
        })
      }
    >
      {children}
    </div>
  );
};
